import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { IMAGES_REPO } from '../../config';

class NextServices extends PureComponent {

  render() {
    const { id, code, image, sub_title, title, numOfComments = 0 } = this.props;
    return (
      <div className="next-service">
        <div className="next-service-link">
          <div className="next-service-hover">
            <div className="next-service-hover-content">
              <Link to={`/events/${code}`}>
                <button className="btn btn-xl">ver mais</button>
              </Link>
            </div>
          </div>
          <img className="img-responsive" src={`${IMAGES_REPO}${image}`} alt={title}/>
        </div>
        <div className="next-service-caption">
          <div className="first">
            <h4>{title}</h4>
            <p className="text-muted">{sub_title}</p>
          </div>
          <div className="last">
            <span className="comments">
              {numOfComments > 0 && <span>{numOfComments} <i className="fa fa-comments"></i></span>}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

NextServices.propTypes = {};
NextServices.defaultProps = {};

export default NextServices;



// WEBPACK FOOTER //
// ./src/components/next-services/NextServices.js